import Pako from 'pako';

import { HighlighterId } from './text/Highlighter';

export interface HighlightableString {
  fullContent: string | Uint8Array;
  originalParts: HighlightableStringPart[];

  /// undefined if no highlighting is happening for this string.
  highlighted?: {
    parts: HighlightableStringPart[];
    terms: HighlightableStringTerm[];
  };
}

export function isHighlightableString(o: any): boolean {
  return (
    typeof o === 'object' &&
    o !== null &&
    (typeof o.fullContent === 'string' || typeof o.fullContent === 'object') &&
    Array.isArray(o.originalParts)
  );
}

export function getFullContent(str: DeepReadonly<HighlightableString>): string {
  let fullContent: string;
  if (typeof str.fullContent === 'string') {
    fullContent = str.fullContent;
  } else {
    fullContent = Pako.inflateRaw(str.fullContent as Uint8Array, { to: 'string' });
  }
  return fullContent;
}

export function makeHighlightableString(s: string): HighlightableString {
  return {
    originalParts: [
      {
        startIndex: 0,
        length: s.length,
      },
    ],
    fullContent: s.length > 100 ? Pako.deflateRaw(s) : s,
  };
}

export interface HighlightableStringConstructionPart {
  content: string;
  cssClasses?: string[];
}

export function makeHighlightableStringWithParts(
  ...parts: HighlightableStringConstructionPart[]
): HighlightableString {
  let originalParts: HighlightableStringPart[] = [];
  let fullContent = '';

  parts.forEach((p) => {
    originalParts.push({
      startIndex: fullContent.length,
      length: p.content.length,
      cssClasses: p.cssClasses,
    });

    fullContent += p.content;
  });

  if (originalParts.length === 0) {
    originalParts = [
      {
        startIndex: 0,
        length: 0,
      },
    ];
  }

  return {
    originalParts,
    fullContent,
  };
}

export interface HighlightableStringPart {
  startIndex: number;
  length: number;
  cssClasses?: string[];

  /// undefined if no highlighting is happening for this part.
  highlighted?: {
    htmlId: string;
    highlightedBy: HighlighterId[];
  };
}

export interface HighlightableStringTerm {
  startIndex: number;
  content: string;

  highlightedBy: HighlighterId;
  partIndices: number[];
  partHtmlIds: string[];
}
